import React, { useState } from "react";
import { Button } from "antd";
import { Copy, Info } from "react-feather";

import PublishTemplateImg from "../../../assets/images/publish_template.png";
import PublishPlanImg from "../../../assets/images/publish_plan.png";

export default function Plan({ onChoosePlan }) {
  const [link, setLink] = useState("foodluv.com/bellacucina");
  return (
    <div className="image-grid-container">
      <div>
        <div className="free-plan-container">
          <div className="d-flex items-center">
            Publish your free FoodLuv Website <Info className="ml-1" />
          </div>
          <div
            onClick={() => {
              navigator.clipboard.writeText(link);
            }}
            className="mt-1 copy-clipboard-container"
          >
            <Copy className="mr-1 cursor-pointer" size={26} />
            {link}
          </div>
          <div>
            <Button
              type="primary"
              className="custom-btn mt-2"
              onClick={() => {}}
            >
              Publish
            </Button>
          </div>
        </div>

        <img
          alt="publish"
          src={PublishTemplateImg}
          className="img-bg-container"
        />
      </div>
      <div>
        <div className="paid-plan-container">
          <div className="d-flex items-center" style={{ color: "#FFD574" }}>
            Want to Publish on your Domain?
            <Info className="ml-1" />
          </div>
          <div className="mt-1">Upgrade and start selling now</div>

          <div>
            <Button
              type="primary"
              className="custom-btn mt-2"
              onClick={() => onChoosePlan()}
            >
              Choose Plan
            </Button>
          </div>
        </div>
        <img
          alt="plan"
          src={PublishPlanImg}
          className="img-bg-container"
        />
      </div>
    </div>
  );
}
